import React from 'react'
import styled from 'styled-components'
import _ from 'lodash'

import { MOBILE_BREAKPOINT } from 'broker/util/constants'

import SLLabelValue from 'broker/views/components/SkeletonLoader/SLLabelValue'
import SLLabelValueCompare from 'broker/views/components/SkeletonLoader/SLLabelValueCompare'
import SLLabelValueSmall from 'broker/views/components/SkeletonLoader/SLLabelValueSmall'

const Title = styled.div`
  display: block;
  color: #8C8C8C;
  font-family: "Circular", sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
  margin-bottom: 4px;
`

const Value = styled.div`
  display: block;
  color: #1c1c1c;
  font-family: "Circular", sans-serif;
  font-size: ${props => props.small ? '22px' : '28px'};
  font-weight: 900;
  line-height: ${props => props.small ? '28px' : '36px'};
  margin-bottom: 4px;
`

const CompareValue = styled.div`
  display: block;
  color: #8C8C8C;
  font-family: "Circular", sans-serif;
  font-size: 16px;
  font-weight: 900;
  line-height: 20px;
`

function getPlaceholder(props) {
  const {compareValue, small} = props
  if (small) {
    return SLLabelValueSmall
  }

  if (_.isNil(compareValue)) {
    return SLLabelValue
  }

  return SLLabelValueCompare
}

const Item = props => {
  const { className, title, value, compareValue, loading, small } = props
  if (loading) {
    const SLPlaceholder = getPlaceholder(props)
    return (
      <div className={className}>
        <SLPlaceholder/>
      </div>
    )
  }
  return (
    <div className={className}>
      {title && <Title>{title}</Title>}
      {value && <Value small={small || false}>{value}</Value>}
      {compareValue && <CompareValue>{compareValue}</CompareValue>}
    </div>
  )
}

export default styled(Item)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  //margin: 0 80px;
  width: 50%;
  min-height: 70px;
  @media${MOBILE_BREAKPOINT} {

  }
  
  :first-child {
    margin-left: 0;
  }
  
  :last-child {
    margin-right: 0;
  }
`
